import iframeHeightSetter from "../../blog/js/iframeHeightSetter";

document.addEventListener('DOMContentLoaded', async () => {
    if (document.querySelector('.article')) {
        iframeHeightSetter('iframe.embed-video');
    }
});
